import React, { useMemo } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Box } from "@mui/material";
import { useNotify } from "hooks";
import { Label16SemiBold, Switch } from "components";
import { updateConfigParameter } from "api";
import { QUERY_KEYS } from "consts";

export const SwitchSelector = ({
  title,
  requesteData
}: {
  title: string;
  requesteData: any
}) => {
  const notify = useNotify();
  const queryClient = useQueryClient();

  const isChecked = useMemo(() => requesteData?.configValue === "true", [requesteData]);

  const { mutateAsync: updateConfigParameterRequest } = useMutation(updateConfigParameter);

  const handleOnChange = (value: boolean) => {
    updateConfigParameterRequest({ id: requesteData?.id as number, value: `${value}` },
      {
        onError: () =>
          notify.error("Failed to update configuration parameters"),
        onSuccess: () => {
          notify.success("Successfully updated configuration parameters");
          queryClient.invalidateQueries([QUERY_KEYS.CONFIG_PARAMETER]);
        },
      })
  }

  return (
    <>
      <Label16SemiBold sx={{ mb: "18px" }}>{title}</Label16SemiBold>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Switch
          isChecked={isChecked}
          onChange={handleOnChange}
        />
      </Box>
    </>
  );
};
